import mappedItemTypes from "services/items/mappedItemTypes";
import { PCW_STEPS } from "../constants";
import { PortfolioItemSelectStep } from "../PortfolioItemSelectStep";

export default function GenerationAssetStep() {
  return (
    <PortfolioItemSelectStep
            stepId={PCW_STEPS.PCW_ADD_GENERATION_ASSET_STEP_ID}
            itemTypeIds={[
                mappedItemTypes.GENERATION_ASSET.id,
            ]}
        />
  )
}
